import ClientsManager from 'graphql/clientsManager';
import { LANDA_API } from 'graphql/config';
import { UPDATE_USER_DETAILS } from 'graphql/mutations/updateUserDetails';

export const updateUserDetails = async (variables: any) => {
  const { authedApolloClient } = ClientsManager.clients[LANDA_API];
  return await authedApolloClient.mutate({
    mutation: UPDATE_USER_DETAILS,
    variables,
    fetchPolicy: 'network-only',
  });
};
